/**
 * Convierte un código de moneda (ISO 4217) a código de país (ISO 3166-1 alpha-2)
 * @param {string} currencyCode - Código de moneda de 3 letras (ej: 'COP', 'USD')
 * @returns {string|null} Código de país de 2 letras o null si no se encuentra
 */

export const currencyToCountry = {
  // A
  AED: 'AE', // Dirham de Emiratos Árabes Unidos
  AFN: 'AF', // Afgani afgano
  ALL: 'AL', // Lek albanés
  AMD: 'AM', // Dram armenio
  AOA: 'AO', // Kwanza angoleño
  ARS: 'AR', // Peso argentino
  AUD: 'AU', // Dólar australiano
  AWG: 'AW', // Florín arubeño
  AZN: 'AZ', // Manat azerbaiyano

  // B
  BAM: 'BA', // Marco convertible de Bosnia-Herzegovina
  BBD: 'BB', // Dólar de Barbados
  BDT: 'BD', // Taka de Bangladesh
  BGN: 'BG', // Lev búlgaro
  BHD: 'BH', // Dinar bahreiní
  BIF: 'BI', // Franco burundés
  BMD: 'BM', // Dólar de Bermudas
  BND: 'BN', // Dólar de Brunéi
  BOB: 'BO', // Boliviano
  BRL: 'BR', // Real brasileño
  BSD: 'BS', // Dólar bahameño
  BTN: 'BT', // Ngultrum butanés
  BWP: 'BW', // Pula de Botsuana
  BYN: 'BY', // Rublo bielorruso
  BZD: 'BZ', // Dólar beliceño

  // C
  CAD: 'CA', // Dólar canadiense
  CDF: 'CD', // Franco congoleño
  CHF: 'CH', // Franco suizo
  CLP: 'CL', // Peso chileno
  CNY: 'CN', // Yuan chino
  COP: 'CO', // Peso colombiano
  CRC: 'CR', // Colón costarricense
  CUP: 'CU', // Peso cubano
  CVE: 'CV', // Escudo caboverdiano
  CZK: 'CZ', // Corona checa

  // D
  DJF: 'DJ', // Franco yibutiano
  DKK: 'DK', // Corona danesa
  DOP: 'DO', // Peso dominicano
  DZD: 'DZ', // Dinar argelino

  // E
  EGP: 'EG', // Libra egipcia
  ERN: 'ER', // Nakfa eritreo
  ETB: 'ET', // Birr etíope
  EUR: 'UE', // Euro (usando tu bandera UE)

  // F
  FJD: 'FJ', // Dólar fiyiano
  FKP: 'FK', // Libra de las Malvinas

  // G
  GBP: 'GB', // Libra esterlina
  GEL: 'GE', // Lari georgiano
  GHS: 'GH', // Cedi ghanés
  GIP: 'GI', // Libra de Gibraltar
  GMD: 'GM', // Dalasi gambiano
  GNF: 'GN', // Franco guineano
  GTQ: 'GT', // Quetzal guatemalteco
  GYD: 'GY', // Dólar guyanés

  // H
  HKD: 'HK', // Dólar de Hong Kong
  HNL: 'HN', // Lempira hondureño
  HRK: 'HR', // Kuna croata
  HTG: 'HT', // Gourde haitiano
  HUF: 'HU', // Forinto húngaro

  // I
  IDR: 'ID', // Rupia indonesia
  ILS: 'IL', // Nuevo séquel israelí
  INR: 'IN', // Rupia india
  IQD: 'IQ', // Dinar iraquí
  IRR: 'IR', // Rial iraní
  ISK: 'IS', // Corona islandesa

  // J
  JMD: 'JM', // Dólar jamaicano
  JOD: 'JO', // Dinar jordano
  JPY: 'JP', // Yen japonés

  // K
  KES: 'KE', // Chelín keniano
  KGS: 'KG', // Som kirguís
  KHR: 'KH', // Riel camboyano
  KMF: 'KM', // Franco comorense
  KPW: 'KP', // Won norcoreano
  KRW: 'KR', // Won surcoreano
  KWD: 'KW', // Dinar kuwaití
  KYD: 'KY', // Dólar de las Islas Caimán
  KZT: 'KZ', // Tenge kazajo

  // L
  LAK: 'LA', // Kip laosiano
  LBP: 'LB', // Libra libanesa
  LKR: 'LK', // Rupia de Sri Lanka
  LRD: 'LR', // Dólar liberiano
  LSL: 'LS', // Loti de Lesoto
  LYD: 'LY', // Dinar libio

  // M
  MAD: 'MA', // Dírham marroquí
  MDL: 'MD', // Leu moldavo
  MGA: 'MG', // Ariary malgache
  MKD: 'MK', // Denar macedonio
  MMK: 'MM', // Kyat birmano
  MNT: 'MN', // Tugrik mongol
  MOP: 'MO', // Pataca de Macao
  MRU: 'MR', // Ouguiya mauritano
  MUR: 'MU', // Rupia mauriciana
  MVR: 'MV', // Rufiyaa maldiva
  MWK: 'MW', // Kwacha malauí
  MXN: 'MX', // Peso mexicano
  MYR: 'MY', // Ringgit malayo
  MZN: 'MZ', // Metical mozambiqueño

  // N
  NAD: 'NA', // Dólar namibio
  NGN: 'NG', // Naira nigeriana
  NIO: 'NI', // Córdoba nicaragüense
  NOK: 'NO', // Corona noruega
  NPR: 'NP', // Rupia nepalí
  NZD: 'NZ', // Dólar neozelandés

  // O
  OMR: 'OM', // Rial omaní

  // P
  PAB: 'PA', // Balboa panameño
  PEN: 'PE', // Sol peruano
  PGK: 'PG', // Kina de Papúa Nueva Guinea
  PHP: 'PH', // Peso filipino
  PKR: 'PK', // Rupia pakistaní
  PLN: 'PL', // Zloty polaco
  PYG: 'PY', // Guaraní paraguayo

  // Q
  QAR: 'QA', // Riyal catarí

  // R
  RON: 'RO', // Leu rumano
  RSD: 'RS', // Dinar serbio
  RUB: 'RU', // Rublo ruso
  RWF: 'RW', // Franco ruandés

  // S
  SAR: 'SA', // Riyal saudí
  SBD: 'SB', // Dólar de las Islas Salomón
  SCR: 'SC', // Rupia de Seychelles
  SDG: 'SD', // Libra sudanesa
  SEK: 'SE', // Corona sueca
  SGD: 'SG', // Dólar singapurense
  SHP: 'SH', // Libra de Santa Elena
  SLL: 'SL', // León de Sierra Leona
  SOS: 'SO', // Chelín somalí
  SRD: 'SR', // Dólar surinamés
  SSP: 'SS', // Libra sursudanesa
  STN: 'ST', // Dobra de Santo Tomé y Príncipe
  SYP: 'SY', // Libra siria
  SZL: 'SZ', // Lilangeni suazi

  // T
  THB: 'TH', // Baht tailandés
  TJS: 'TJ', // Somoni tayiko
  TMT: 'TM', // Manat turcomano
  TND: 'TN', // Dinar tunecino
  TOP: 'TO', // Paanga tongano
  TRY: 'TR', // Lira turca
  TTD: 'TT', // Dólar de Trinidad y Tobago
  TWD: 'TW', // Nuevo dólar taiwanés
  TZS: 'TZ', // Chelín tanzano

  // U
  UAH: 'UA', // Grivna ucraniana
  UGX: 'UG', // Chelín ugandés
  USD: 'US', // Dólar estadounidense
  UYU: 'UY', // Peso uruguayo
  UZS: 'UZ', // Som uzbeko

  // V
  VES: 'VE', // Bolívar venezolano
  VND: 'VN', // Dong vietnamita
  VUV: 'VU', // Vatu vanuatuense

  // W
  WST: 'WS', // Tala samoana

  // X
  XAF: 'CM', // Franco CFA de África Central (Camerún como representante)
  XCD: 'AG', // Dólar del Caribe Oriental (Antigua y Barbuda como representante)
  XOF: 'SN', // Franco CFA de África Occidental (Senegal como representante)
  XPF: 'PF', // Franco CFP (Polinesia Francesa)

  // Y
  YER: 'YE', // Rial yemení

  // Z
  ZAR: 'ZA', // Rand sudafricano
  ZMW: 'ZM', // Kwacha zambiano
  ZWL: 'ZW', // Dólar zimbabuense
};

export const currencyToCountryCode = (currencyCode: string) => {
  // Normalizar a mayúsculas
  const normalizedCode = currencyCode?.toUpperCase();

  return currencyToCountry[normalizedCode] || null;
};
